export default {
  // Mine-marker tooltip, first line. `{metal}` is interpolated with the (already
  // translated) metal name; the place/site line beneath it is raw data (no i18n).
  mineLabel: {
    id: 'rm_map_marker_mine_label',
    defaultMessage: '{metal} mine',
  },
  // Impact-story marker tooltip, first line — same shape, "story" instead of "mine".
  storyLabel: {
    id: 'rm_map_marker_story_label',
    defaultMessage: '{metal} story',
  },
} as const
